import request from '@/utils/request'

/** 门店驾驶舱月度统计（人头/人次/项目/消耗/退卡/目标/完成率） */
export function getStoreDashboardStatistics(data) {
  return request({
    url: '/api/Extend/LqStoreDashboard/GetStatistics',
    method: 'post',
    data
  })
}

/** 门店按日运营统计（今日人头/人次/项目/消耗） */
export function getStoreDailyStatistics(data) {
  return request({
    url: '/api/Extend/LqDailyReport/get-store-daily-statistics',
    method: 'post',
    data
  })
}

/** 门店业绩完成情况（今日退卡金额等，按日期范围） */
export function getStorePerformanceCompletion(data) {
  return request({
    url: '/api/Extend/LqDailyReport/get-store-performance-completion',
    method: 'post',
    data
  })
}

/** 获取沉睡会员列表（门店PC） */
export function getSleepingMembers(data) {
  return request({
    url: '/api/Extend/LqStoreDashboard/GetSleepingMembers',
    method: 'post',
    data
  })
}

/** 获取公司日历事件列表（不分页，用于日历展示） */
export function getCalendarEventList(data) {
  return request({
    url: '/api/Extend/LqCompanyCalendar/GetCalendarEventList',
    method: 'post',
    data
  })
}

/** 获取事件类型列表 */
export function getEventTypeList(data) {
  return request({
    url: '/api/Extend/LqCompanyCalendar/GetEventTypeList',
    method: 'post',
    data
  })
}
